import { ReactNode, useId } from 'react'
import { ChevronDown } from 'lucide-react'

/**
 * Acordeón del kit (`dcc-accordion`): un contenedor con secciones que se abren y cierran.
 * Cada `AcordeonItem` es un botón (con `aria-expanded` y `aria-controls`) y su panel; el
 * panel se anima con `data-open`, como trae el kit. `ancho` quita el máximo de 640px del
 * kit, para usarlo en una página. El contenido de un panel cerrado no se monta.
 */
export function Acordeon({ children, ancho = false, className = '' }: { children: ReactNode; ancho?: boolean; className?: string }) {
  return <div className={['dcc-accordion', ancho && 'acordeon--ancho', className].filter(Boolean).join(' ')}>{children}</div>
}

export function AcordeonItem({
  titulo, abierto, onAlternar, children,
}: {
  titulo: ReactNode
  abierto: boolean
  onAlternar: () => void
  children: ReactNode
}) {
  const id = useId()
  return (
    <div className="dcc-accordion__item">
      <button type="button" className="dcc-accordion__trigger" aria-expanded={abierto} aria-controls={`${id}-panel`} id={`${id}-boton`} onClick={onAlternar}>
        <span className="acordeon__titulo">{titulo}</span>
        <ChevronDown className="dcc-i" aria-hidden />
      </button>
      <div className="dcc-accordion__panel" data-open={abierto} id={`${id}-panel`} role="region" aria-labelledby={`${id}-boton`}>
        <div>{abierto && children}</div>
      </div>
    </div>
  )
}
